import { identity } from "@/utils/functions"

const featureFlag = true; // Turn this on ONLY in PRODUCTION
const GA_key = "_ga"; // key in GDPR
const ua = "UA-160429956-1";

const ga_url = ua => `https://www.googletagmanager.com/gtag/js?id=${ua}`;

const GA = {
	loaded: false,
	load(vm){
		const shouldNotLoad = [
			!featureFlag,
			this.loaded,
			!vm.$gdpr_serde.exists(),
			!vm.$gdpr.isEnabled(GA_key),
		].some(identity); // if one of these is true, do not load

		if(shouldNotLoad)
			return;

		this.loaded = this.__inject();
		return this.loaded;
	},
	__inject(){
		const loader = document.createElement("script");
		// loader.setAttribute("async", "");
		loader.async = true;
		loader.setAttribute("src", ga_url(ua));

		const boot = document.createElement("script");
		// textContent, innerText, innerHTML
		boot.innerHTML = `
			window.dataLayer = window.dataLayer || [];

			function gtag(){
				dataLayer.push(arguments);
			}

			gtag("config", "${ua}");
		`;

		[loader, boot]
		.forEach(e => document.body.appendChild(e)); //document.head
		//console.log("appended");

		return true;
	}
};

export default {
	install(Vue){
		[Vue, Vue.prototype]
		.forEach(target => Object.defineProperties(target, {
			$ga: {
				get(){
					return GA;
				},
			}
		}));
	}
}
